import { supabase } from './supabase';
import { parsePerformance, type NetworkPerformance } from './performance';

/**
 * Performance réseau (brique E) — lecture via RPC sécurisée `network_performance`
 * (super_admin only, cf. sql/26_performance.sql). Logique pure dans performance.ts.
 */

export interface LoadPerformanceResult {
  ok: boolean;
  data: NetworkPerformance;
  error?: string;
}

const EMPTY: NetworkPerformance = { windowDays: 30, tenants: [] };

/** Charge la performance réseau sur `days` jours glissants. */
export async function loadPerformance(days = 30): Promise<LoadPerformanceResult> {
  const { data, error } = await supabase.rpc('network_performance', { p_days: days });
  if (error) {
    return { ok: false, data: EMPTY, error: error.message };
  }
  return { ok: true, data: parsePerformance(data) };
}
